import { render, staticRenderFns } from "./ContactsCalendar.vue?vue&type=template&id=b9fa92ac&scoped=true&"
import script from "./ContactsCalendar.vue?vue&type=script&lang=js&"
export * from "./ContactsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ContactsCalendar.vue?vue&type=style&index=0&id=b9fa92ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fa92ac",
  null
  
)

export default component.exports